import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/adquisiciones/devoluciones/crear', documento: 'adquisiciones', acceso: 'sesion', filas: ['053'],
  cita: 'Areas/Adquisiciones/Controllers/DevolucionesController.cs',
} satisfies RutaProd;
